module.exports = __webpack_public_path__ + "img/Planta.07df343a.jpeg";